import axios from "axios";
import {
    IP
} from "../index";

/* 血压测量仪管理 */

// 查询
export async function selectApi() {
    var resp = await axios.post(`${IP}/admin/instrumentList/select`, {

    });
    return resp.data;
}
// 删除
export async function deleteApi(id) {
    var resp = await axios.post(`${IP}/admin/instrumentList/delete`, {
        id
    });
    return resp.data;
}

// 新增
export async function addApi(data) {
    var resp = await axios.post(`${IP}/admin/instrumentList/add`, {
        ...data
    });
    return resp.data;
}

// 修改
export async function updateApi(data) {
    var resp = await axios.post(`${IP}/admin/instrumentList/update`, {
        ...data
    });
    return resp.data;
}